import { render, staticRenderFns } from "./cargoLocationSelect.vue?vue&type=template&id=44317e4c&"
import script from "./cargoLocationSelect.vue?vue&type=script&lang=js&"
export * from "./cargoLocationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44317e4c')) {
      api.createRecord('44317e4c', component.options)
    } else {
      api.reload('44317e4c', component.options)
    }
    module.hot.accept("./cargoLocationSelect.vue?vue&type=template&id=44317e4c&", function () {
      api.rerender('44317e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoLocationSelect.vue"
export default component.exports